<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="View Log Book">
      <a @click="$router.back()">
        <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
          <v-icon left>mdi-arrow-left</v-icon>back
        </v-btn>
        <v-btn
          v-else
          fixed
          right
          fab
          small
          color="grey lighten-2"
          elevation="1"
          class="mr-n2 mt-10"
          style="opacity:.6;"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </a>
      <v-card-component>
        <v-row>
          <v-col cols="4" md="3">
            <span class="desc">
              <v-icon color="primary">mdi-account</v-icon>
              <span class="label-color">Name:</span>
              {{this.logData[0].teacherName[0].user.firstName+" "+this.logData[0].teacherName[0].user.lastName}}
            </span>
          </v-col>
          <v-col cols="4" md="3">
            <label class="font-weight-medium body-2">From Date</label>
            <custom-date-picker v-model="fromDate" />
          </v-col>
          <v-col cols="4" md="3">
            <label class="font-weight-medium body-2">To Date</label>
            <custom-date-picker v-model="toDate" :minToDate="fromDate" />
          </v-col>
          <v-col cols="4" md="3">
            <v-btn color="success" elevation="1" @click="getLogDetails()">
              <v-icon left size="20">mdi-equal-box</v-icon>Filter Logs
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-card flat class="pb-12">
              <v-card-text>
                <v-tabs v-model="tabIndex" @change="tabChange()" background-color center-active>
                  <v-tabs-slider color></v-tabs-slider>
                  <v-tab v-for="(date,index) of groupDates" :key="index">{{date}}</v-tab>
                </v-tabs>

                <v-divider class="my-0 v-divider theme--light"></v-divider>
                <br />
                <br />

                <v-tabs-items v-model="tabIndex">
                  <v-tab-item v-for="(date, index) of groupDates" :key="index">
                    <v-data-table
                      :headers="headers"
                      :items="groupedTopicData[date]"
                      :footer-props="{
              'items-per-page-options': [5, 10, 20, 40]
            }"
                      :items-per-page="10"
                    >
                      <template
                        v-slot:item.content="{ item }"
                      >{{ item.content ? item.content : '-' }}</template>
                      <template
                        v-slot:item.resourcesRequired="{ item }"
                      >{{ item.resourcesRequired ? item.resourcesRequired : '-' }}</template>
                      <template
                        v-slot:item.teacherTask="{ item }"
                      >{{ item.teacherTask ? item.teacherTask : '-' }}</template>
                      <template
                        v-slot:item.parentTask="{ item }"
                      >{{ item.parentTask ? item.parentTask : '-' }}</template>
                      <template
                        v-slot:item.outcomeofTheClass="{ item }"
                      >{{ item.outcomeofTheClass ? item.outcomeofTheClass : '-' }}</template>
                      <template
                        v-slot:item.outcomeToBeObserved="{ item }"
                      >{{ item.outcomeToBeObserved ? item.outcomeToBeObserved : '-' }}</template>
                      <template
                        v-slot:item.furtherStepsPlanned="{ item }"
                      >{{ item.furtherStepsPlanned ? item.furtherStepsPlanned : '-' }}</template>
                      <template v-slot:no-data>
                        <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
                      </template>
                    </v-data-table>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-textarea
                          hide-details
                          class="my-0 py-1"
                          label="Remarks"
                          clearable
                          v-model.trim="remark"
                          clear-icon="mdi-close-circle"
                          auto-grow
                          rows="3"
                          row-height="25"
                          placeholder="Add Remarks"
                        ></v-textarea>
                      </v-col>
                      <v-col>
                        <v-card-actions class="d-flex justify-end">
                          <v-btn
                            bottom
                            right
                            @click="sendRemark"
                            elevation="1"
                            color="primary"
                            type="button"
                          >
                            <v-icon left>mdi-content-save</v-icon>Send
                          </v-btn>
                        </v-card-actions>
                      </v-col>
                    </v-row>
                    <br />
                    <v-row>
                      <v-col cols="12">
                        <h3 style="font-size:18px; font-weight: 500; color:#000;">Remark Lists</h3>
                      </v-col>
                    </v-row>
                    <v-data-table
                      :headers="headerRemark"
                      :items="groupRemarkData[groupDates[tabIndex]]"
                      :footer-props="{
              'items-per-page-options': [5, 10, 20, 40]
            }"
                      :items-per-page="10"
                    >
                      <template
                        v-slot:item.remarkByName="{ item }"
                      >{{ `${item.remarkByName.firstName} ${item.remarkByName.lastName}` ? `${item.remarkByName.firstName} ${item.remarkByName.lastName}` : '-' }}</template>
                      <template v-slot:item.remark="{ item }">{{ item.remark ? item.remark : '-' }}</template>
                      <template
                        v-slot:item.remarkDate="{ item }"
                      >{{ new Date(item.remarkDate).toLocaleDateString() || '-' }}</template>

                      <template v-slot:no-data>
                        <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
                      </template>
                    </v-data-table>
                    <!-- <v-row
                      v-for="(item,index) of groupRemarkData[groupDates[tabIndex]]"
                      :key="index"
                    >
                      <v-col cols="12" sm="12" md="8">
                        <h3 style="font-size:16px; font-weight: 500; color:#000;">
                          {{item.remarkByName.firstName}}
                          {{item.remarkByName.lastName}}
                        </h3>
                        <h4 style="font-size:14px; font-weight: 400; color:#000;">{{item.remark}}</h4>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <h4
                          style="font-size:14; font-weight: 400;text-align:right; color:#000;"
                        >{{item.remarkDate}}</h4>
                      </v-col>
                    </v-row>-->
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-component>
      <!-- end -->
    </material-card>
  </v-container>
</template>

<script>
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
// import { mapGetters } from 'vuex'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import _ from 'lodash'
import Utils from '@/utils'
import moment from 'moment'

export default {
  components: { VCardComponent, MaterialCard, CustomDatePicker },
  props: ['teacherID'],
  name: 'viewLogBookEntryList',
  async created () {
    this.toDate = new Date().toISOString().slice(0, 10)
    let d = new Date()
    let previousDate = d.setDate(d.getDate() - 30)
    this.fromDate = new Date(previousDate).toISOString().slice(0, 10)
    // console.log('this.toDate ', this.toDate)
    // console.log('this.fromDate ', this.fromDate)
    await this.getLogDetails()
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
  },
  computed: {},
  watch: {},
  data () {
    return {
      teacherName: [],
      isWrite: true,
      logDate: '',
      logData: [],
      content: '',
      logBookTopicMapsData: [],
      groupedData: {},
      groupDates: [],
      groupedTopicData: {},
      groupRemarkData: {},
      tabIndex: 0,
      remark: '',
      isDisabled: false,
      logBookID: '',
      isPublished: false,
      //  currentDate: new Date().toISOString().slice(0, 10),
      fromDate: '',
      toDate: '',
      // isRemark: false,
      headers: [
        { text: 'Topic Name', sortable: true, value: 'topicName[0].name' },
        { text: 'Content', sortable: true, value: 'content' },
        { text: 'Resources', sortable: true, value: 'resourcesRequired' },
        { text: 'Teacher Task', sortable: true, value: 'teacherTask' },
        { text: 'Parent Task', sortable: true, value: 'parentTask' },
        { text: 'Expected Outcomes', sortable: true, value: 'outcomeofTheClass' },
        { text: 'Observed Outcomes', sortable: true, value: 'outcomeToBeObserved' },
        { text: 'Future Plans', sortable: true, value: 'furtherStepsPlanned' }
      ],
      headerRemark: [
        { text: 'Remark By', sortable: true, value: 'remarkByName' },
        { text: 'Remark', sortable: true, value: 'remark' },
        { text: 'Remark Date', sortable: true, value: 'remarkDate' }
      ]
    }
  },
  methods: {
    getLogDetails: async function () {
      try {
        // if (this.academicYear.id) {

        let rows = await http.get(`${constants.API_URL}/api/log-book/getlogbook/${this.teacherID}`, {
          params: {
            isPublish: true,
            fromDate: this.fromDate,
            toDate: this.toDate
          }
        })
        this.logData = rows.data.rows
        // console.log(this.logData[0].teacherName[0].user.firstName, 'Lists')

        this.groupedData = _.groupBy(rows.data.rows, 'Date')
        // this.groupedData = this.groupedData.reverse()
        this.groupDates = Object.keys(this.groupedData)

        this.groupDates = this.groupDates.sort((a, b) => Date.parse(new Date(a)) - Date.parse(new Date(b))).reverse()
        this.groupDates.forEach(date => {
          this.groupedTopicData[date] = []
          this.groupRemarkData[date] = []

          this.groupedData[date].forEach(data => {
            this.groupedTopicData[date] = this.groupedTopicData[date].concat(data.logBookTopicMaps)
            this.groupRemarkData[date] = this.groupRemarkData[date].concat(data.logBookRemarks)
          })
        })
        // console.log(this.groupRemarkData, 'groupDatesRemark')
        console.log(this.groupedData, 'Data')
        this.logData.logDate = moment(this.logData.Date).format('DD-MM-YYYY')
        this.tabChange()
      } catch (e) {
        console.log(e)
        return this.$dialog.error({
          text: (e && e.response && e.response.data.message) || e.message,
          title: 'Error'
        })
      }
    },
    tabChange () {
      this.remark = ''
      this.logData.forEach(item => {
        if (item.Date === this.groupDates[this.tabIndex]) {
          if (item.logBookRemarks.length > 0) {
            // this.remark = item.logBookRemarks[0].remark
            // this.isRemark = true
          } // else {
          //   this.isRemark = false
          // }
        }
      })
    },
    sendRemark: async function () {
      this.logBookID = this.groupedTopicData[this.groupDates[this.tabIndex]][0].logBookID

      try {
        // console.log(this.remark, 'Remark item')
        // if (this.remark === '') {
        //   // console.log(this.remark, 'test remark')
        //   // this.errMsg()
        //   // return false
        // }
        this.isLoading = true
        let formData = {
          remark: this.remark,
          remarkDate: this.currentDate
        }
        let res = await http.post(`${constants.API_URL}/api/log-book/add-remark/${this.logBookID}`, formData)
        this.okMsg(res.data)
        this.getLogDetails()
        this.isLoading = false
        this.remark = ''
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
      }
    },
    resetAll: async function () {
      this.remark = ''
    },
    // getDisabled (remark) {
    //   // if (remark === '') {
    //   //   return false
    //   // } else {
    //   //   return true
    //   // }
    //   return remark.length > 0
    // },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style scoped>
.desc {
  font-size: 18px;
  text-transform: capitalize;
}
.label-color {
  color: rgba(0, 0, 0, 0.87);
  font-weight: 400;
}
</style>
